import type { FC, ReactNode, MouseEventHandler } from 'react';
import { cn } from '../../lib/utils';

interface IconButtonProps {
  onClick: MouseEventHandler;
  children: ReactNode;
  title?: string;
  tooltipPosition?: 'above' | 'below';
  tooltipAlign?: 'center' | 'end';
  size?: 'default' | 'card';
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export const IconButton: FC<IconButtonProps> = ({
  onClick,
  children,
  title,
  tooltipPosition = 'below',
  tooltipAlign = 'center',
  size = 'default',
  disabled,
  className,
  ...rest
}) => (
  <span className="relative group inline-flex">
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        size === 'card'
          ? 'p-1 rounded border border-foreground/25 text-muted-foreground hover:text-foreground dark:border-transparent dark:bg-secondary dark:text-secondary-foreground dark:hover:opacity-80 disabled:opacity-50 transition-colors'
          : 'p-2 rounded-lg border border-foreground/25 bg-background text-muted-foreground hover:text-foreground dark:border-transparent dark:bg-primary dark:text-primary-foreground dark:hover:opacity-90 disabled:opacity-50 transition-all',
        className
      )}
      {...rest}
    >
      {children}
    </button>
    {title && (
      <span className={cn(
        'pointer-events-none absolute px-2 py-1 text-xs rounded bg-foreground text-background whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-50',
        tooltipPosition === 'above' ? 'bottom-full mb-1.5' : 'top-full mt-1.5',
        tooltipAlign === 'end' ? 'right-0' : 'left-1/2 -translate-x-1/2'
      )}>
        {title}
      </span>
    )}
  </span>
);
